import React from "react";

const toneStyles = {
  info: "border-[#F4F6F8] bg-white text-[#111111]",
  error: "border-[#FFE8E1] bg-[#FFF4EF] text-[#8A1500]",
};

const AppStateScreen = ({
  title = "Please wait",
  message = "",
  tone = "info",
  actionLabel = "",
  onAction,
  secondaryActionLabel = "",
  onSecondaryAction,
}) => {
  const style = toneStyles[tone] || toneStyles.info;
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#F4F6F8]">
      <div
        className={`w-full max-w-md rounded-lg border p-6 shadow-sm ${style}`}
      >
        <h1 className="text-lg font-semibold">{title}</h1>
        <p className="text-sm mt-2">
          {message || "Please try again in a moment."}
        </p>
        {actionLabel || secondaryActionLabel ? (
          <div className="mt-4 flex flex-wrap gap-2">
            {actionLabel && typeof onAction === "function" ? (
              <button
                type="button"
                className="rounded-md bg-[#0B4DB8] px-3 py-2 text-sm font-semibold text-white"
                onClick={onAction}
              >
                {actionLabel}
              </button>
            ) : null}
            {secondaryActionLabel && typeof onSecondaryAction === "function" ? (
              <button
                type="button"
                className="rounded-md border border-[#0B4DB8] bg-white px-3 py-2 text-sm font-semibold text-[#0B4DB8]"
                onClick={onSecondaryAction}
              >
                {secondaryActionLabel}
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AppStateScreen;
